import { css } from "@emotion/css";
import React from "react";
import { Container, Icon } from "semantic-ui-react";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";
import "../../styles/empty-state.scss";
import "../../styles/main.scss";

interface BCEmptyStateProps {
    icon?: any;
    text?: string;
    button?: any;
    emptyStateClass?: string;
    className?: string;
    brokerColor?: string;
    content?: any;
  }
  
const BCEmptyState = ({...props}: BCEmptyStateProps) => {
  const brokerIconColorOverride = css`
    color: ${props.brokerColor ? props.brokerColor : "black"} !important;
    font-family: $fontFamily !important;
    margin-top: 10px;
    width: 25%;
  `;
  return (
    <div className={`center-empty-state vertical-center ${props.emptyStateClass ? props.emptyStateClass : "center-empty-state-default"}`}>
      <Container className="vertical-center" fluid>
          {props.icon && <Icon className={getIsWhiteLabeled() ? brokerIconColorOverride : props.className} name={props.icon} size='huge'/>}
          {props.text && <p className="bc-empty-state-text">
              {props.text}
          </p>}
          {props.button && <React.Fragment>{props.button}</React.Fragment>}
          {props.content && props.content}
      </Container> 
    </div>
  );
};
export default BCEmptyState;